:host([light]) {
    & .scheduled_backups_st0 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: #ffffff;
    }
    & .scheduled_backups_st1 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: #bbdefb;
    }
    & .scheduled_backups_st2 {
        fill: #1a4e85;
    }
    & .scheduled_backups_st3 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#scheduled_backups_SVGID_1_);
    }
    & .scheduled_backups_st4 {
        fill: none;
        stroke: #1a4e85;
        stroke-width: 6;
        stroke-linejoin: round;
    }
    & .scheduled_backups_st5 {
        fill: none;
        stroke: #1a4e85;
        stroke-width: 3;
        stroke-miterlimit: 10;
    }
}
:host([dark]) {
    & .scheduled_backups_st0 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: #ced4db;
    }
    & .scheduled_backups_st1 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: #09264a;
    }
    & .scheduled_backups_st2 {
        fill: #09264a;
    }
    & .scheduled_backups_st3 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: url(#scheduled_backups_SVGID_1_);
    }
    & .scheduled_backups_st4 {
        fill: none;
        stroke: #ffffff;
        stroke-width: 6;
        stroke-linejoin: round;
    }
    & .scheduled_backups_st5 {
        fill: none;
        stroke: #09264a;
        stroke-width: 3;
        stroke-miterlimit: 10;
    }
}
